import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
// Define the initial state using that type
const initialState: any = {
  events: {
    pagination: {
      total: 0,
      page: 1,
      elements: 10
    },
    data: []
  },
  eventsCategories: [],
  selectedEvent:null,
  eventCategoryId:1,
};

export const eventsSlice = createSlice({
  name: 'eventsSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateEvents: (state, action) => {
      state.events = action.payload;
    },
    updateEventsCategory: (state, action) => {
      state.eventsCategories = action.payload;
    },
    updateEventCategoryId: (state, action) => {
      state.eventCategoryId = action.payload;
    },
    addEventsCategory: (state, action) => {
      if(state.eventsCategories && !state.eventsCategories?.includes(action.payload)) {
        state.eventsCategories.push(action.payload);
      }
    },
    updateSelectedEvent: (state, action) => {
      state.selectedEvent = action.payload;
    },
  },
});

export const { updateEvents, updateEventsCategory, updateSelectedEvent, addEventsCategory, updateEventCategoryId } = eventsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const eventsState = (state: RootState) => state.events.events;
export const eventsCategoriesState = (state: RootState) => state.events.eventsCategories;
export const selectedEvent = (state: RootState) => state.events.selectedEvent;
export const eventCategoryId = (state: RootState) => state.events.eventCategoryId;

export default eventsSlice.reducer;
